import { Redirect, Route, RouteComponentProps, Switch } from 'react-router-dom';
import { Container, Heading } from 'yoso';
import { HelpContact } from '~/components/Help/Contact';
import { HelpCategoryContainer } from '~/components/Help/List/HelpCategoryContainer';
import { HelpCategoryNav } from '~/components/Help/Nav/HelpCategoryNav';
import { Translation } from '~/components/I18n';
import { Page } from '~/components/Page';
import './HelpCategoryPage.scss';

export const HelpCategoryPage = ({ match: { path } }: RouteComponentProps) => (
  <Page className="help-category-page" data-event-page_name="Help">
    <Container margin="auto">
      <div className="help-category-page-header">
        <Heading level={1}>
          <Translation name="citizen_help" />
        </Heading>
        <HelpCategoryNav className="help-category-nav" />
      </div>
      <div className="help-category-page-body">
        <Switch>
          <Route path={`${path}/document/:documentId?`} component={HelpCategoryContainer} />
          <Redirect from={path} to={`${path}/document`} />
        </Switch>
      </div>
      <div className="help-category-page-footer">
        <HelpContact />
      </div>
    </Container>
  </Page>
);
